import { TrendingForYouLook } from "../../../domain/projections/TrendingForYouLook";
import { Container } from "../../ui/shared/types";

interface TrendingForYouLookDTO {
  readonly layout: string;
  readonly lookId: string;
  readonly items: {
    readonly imageUrl: string;
    readonly variantId: string;
    readonly container: string;
  }[];
}

const mapTrendingForYouLookDTOtoTrendingForYouLook = (lookDTO: TrendingForYouLookDTO): TrendingForYouLook => {
  return {
    layout: lookDTO.layout,
    lookId: lookDTO.lookId,
    items: lookDTO.items.map((item) => ({
      imageUrl: item.imageUrl,
      variantId: item.variantId,
      container: item.container as Container,
    })),
  };
};

export type { TrendingForYouLookDTO };
export { mapTrendingForYouLookDTOtoTrendingForYouLook };
